import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boardFilter'
})
export class boardFilter implements PipeTransform {
    transform(items: any[], boardSearch: string | number): any[] {    
        if (!items) return [];
        if (!boardSearch) return items;
    
        const searchLower = boardSearch.toString().toLowerCase();
    
        return items.filter(item => {
          const value = item['name']; // Assuming 'name' is the field to filter    
          if (value === undefined || value === null) {
            console.warn('Field "name" is undefined or null in item:', item);
            return false;
          }
    
          const valueStr = value.toString().toLowerCase();
          return valueStr.includes(searchLower);
        });
      }
    }
    